import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CommentId, CommentSubject } from 'models/Comment';
import {
  commentQuery,
  commentsQuery,
} from 'networking/mindfeed/queries/comments';
import { deleteComment } from 'networking/mindfeed/services/comment.service';

type Variables = {
  commentId: CommentId;
  subject: CommentSubject;
  parentId?: CommentId;
};

export const useDeleteComment = ({
  onSuccess,
}: {
  onSuccess?: () => void;
} = {}) => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, Variables>({
    mutationFn: ({ commentId }) => deleteComment(commentId),
    onSuccess: (_data, { subject, parentId }) => {
      queryClient.invalidateQueries({
        queryKey: commentsQuery(subject).queryKey,
      });
      if (parentId) {
        queryClient.invalidateQueries({
          queryKey: commentQuery(parentId).queryKey,
        });
      }
      onSuccess?.();
    },
  });
};
